import styled from 'styled-components';
import { Typ31 } from 'dc/Typ';

export const TitleWrapper = styled.div`
  display: flex;
  background-color: #f4f7f9;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled(Typ31)`
  display: block;
  padding: 16px 16px 12px;
`;
